import React from 'react'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { Info } from 'lucide-react'
import { ICON_SIZE_3 } from '@/utils/constant'

type SwitchFieldProps = {
    label?: string
    name: string
    error?: string
    isRequired?: boolean
    hasInfo?: boolean
    infoMessage?: string
    showHelpText?: boolean
    helpText?: string
    checked?: boolean
    onCheckedChange?: (checked: boolean) => void
    disabled?: boolean
    className?: string
}

const SwitchField: React.FC<SwitchFieldProps> = ({
    label = '',
    error,
    className,
    isRequired,
    hasInfo,
    infoMessage,
    showHelpText,
    helpText,
    checked = false,
    onCheckedChange,
    disabled = false,
    name
}) => {
    return (
        <div className={`mb-4 ${className || ''}`}>
            {label && (
                <Label htmlFor={name} className="text-sm font-medium mb-1 flex items-center gap-1">
                    {label}
                    {hasInfo && (
                        <TooltipProvider>
                            <Tooltip>
                                <TooltipTrigger asChild>
                                    <Info size={ICON_SIZE_3} />
                                </TooltipTrigger>
                                <TooltipContent className="w-90">
                                    <p>{infoMessage}</p>
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider>
                    )}
                    {isRequired && <span className="text-red-600 font-medium"> *</span>}
                </Label>
            )}

            <Switch
                id={name}
                checked={checked}
                onCheckedChange={onCheckedChange}
                disabled={disabled}
            />

            {showHelpText && <p className="mt-1 text-gray-500 text-sm">{helpText}</p>}

            {error && <p className="mt-1 text-sm text-red-600 font-medium">{error}</p>}
        </div>
    )
}

export default SwitchField
